import {CartItem} from "../../providers/types";
import React from "react";
import {useColors} from "../../providers/queryClient";

export interface CartItemComponentProps {
    item: CartItem;
}

export const CartItemComponent = ({item}: CartItemComponentProps) => {
    // const {data} = useColors();
    // const productData = PRODUCTS.find(p => p._id === item.productId);
    //
    // if (!productData || !data) {
    //     //TODO - show error
    //     return null;
    // }
    //
    // const color = data.find(d => d.code === item.config.color);
    //
    // return (
    //     <>
    //         <li className="flex px-4 py-6 sm:px-6">
    //             <div className="flex-shrink-0">
    //                 <img alt={productData.name}
    //                      src={productData.icon}
    //                      className="w-12 rounded-md"/>
    //             </div>
    //
    //             <div className="ml-6 flex flex-1 flex-col">
    //                 <div className="flex">
    //                     <div className="min-w-0 flex-1">
    //                         <h4 className="text-sm">
    //                             <span className="font-medium text-gray-700 hover:text-gray-800">
    //                                 {productData.name}
    //                             </span>
    //                         </h4>
    //                         {/*<p className="mt-1 text-sm text-gray-500">Wysokość - {item.config.height}</p>*/}
    //                         {/*<p className="mt-1 text-sm text-gray-500">Szerokość - {item.config.radius}</p>*/}
    //                         {productData.configuration.map(c => (
    //                             // @ts-ignore
    //                             <p key={c.name} className="mt-1 text-sm text-gray-500">{c.title} - {item.config[c.name]}</p>
    //                         ))}
    //                         <div className="mt-4 flex space-x-2 text-sm text-gray-700">
    //                             <div style={{
    //                                 width: 16,
    //                                 height: 16,
    //                                 borderRadius: 50,
    //                                 backgroundColor: color?.code,
    //                             }}></div>
    //                             <span>{color?.name} / {item.variant.name}</span>
    //                         </div>
    //                     </div>
    //
    //                     <div className="ml-4 flow-root flex-shrink-0">
    //                         <button
    //                             type="button"
    //                             className="-m-2.5 flex items-center justify-center bg-white p-2.5 text-gray-400 hover:text-gray-500"
    //                         >
    //                             <span className="sr-only">Remove</span>
    //                             {/*<TrashIcon aria-hidden="true" className="h-5 w-5"/>*/}
    //                         </button>
    //                     </div>
    //                 </div>
    //
    //                 <div className="flex flex-1 items-end justify-between pt-2">
    //                     <p className="mt-1 text-sm font-medium text-gray-900">{item.price || 89.99} zł</p>
    //
    //                     <div className="ml-4">
    //                         <label htmlFor="quantity" className="sr-only">
    //                             Quantity
    //                         </label>
    //                         <select
    //                             id="quantity"
    //                             name="quantity"
    //                             className="rounded-md border border-gray-300 text-left text-base font-medium text-gray-700 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
    //                         >
    //                             <option value={1}>1</option>
    //                             <option value={2}>2</option>
    //                             <option value={3}>3</option>
    //                             <option value={4}>4</option>
    //                             <option value={5}>5</option>
    //                             <option value={6}>6</option>
    //                             <option value={7}>7</option>
    //                             <option value={8}>8</option>
    //                         </select>
    //                     </div>
    //                 </div>
    //             </div>
    //         </li>
    //     </>
    // );

    return null;
}

export default CartItemComponent;